export const generatePastelColors = (n) => {
  const pastels = [];

  for (let i = 0; i < n; i++) {
    const hue = (i * 137.508) % 360;
    const saturation = 30 + Math.random() * 20;
    const lightness = 80 + Math.random() * 15;
    const pastel = `hsl(${hue}, ${saturation}%, ${lightness}%)`;

    pastels.push(pastel);
  }

  return pastels;
};

export const staticColors = [
  '41c9b0',
  '1bbbff',
  'ff9a8c',
  'f9ba80',
  '82e18b',
  '80c3ff',
  'ffc0b7',
  'b0ebb7',
  'd5dae2',
  '90d6c8',
  '79c9f6',
  'f5bbb1',
  'f4d0ab',
  'b2e3b0',
  'afd4fb',
  'f8d4cd',
  'd0efcf',
  'e2e5ea',
  'aee2d8',
  '9edbfb',
  'f7cec7',
  'f0d8bd',
  'c9eec8',
  'c5e0fc',
  'ecd4d0',
  'def4dd',
  'eaecf0',
  '41c9b0',
  '1bbbff',
  'ff9a8c',
  'f9ba80',
  '82e18b',
  '80c3ff',
  'ffc0b7',
  'b0ebb7',
  'd5dae2',
  '90d6c8',
  '79c9f6',
  'f5bbb1',
  'f4d0ab',
  'b2e3b0',
  'afd4fb',
  'f8d4cd',
  'd0efcf',
  'e2e5ea',
  'aee2d8',
  '9edbfb',
  'f7cec7',
  'f0d8bd',
  'c9eec8',
  'c5e0fc',
  'ecd4d0',
  'def4dd',
  'eaecf0'
];

export const staticHexColors = staticColors.map((color) => `#${color}`);
